import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import { dateFormat } from 'constants/formats';

import Button from 'modules/_shared/components/Buttons';

import { useAddTradingOfferPage } from '../context/AddTradingOfferPageContext';

const AddTradingOfferResumeSection: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddTradingOfferPage();

  const isValidateDates =
    data.startDate &&
    data.endDate &&
    new Date(data.startDate) < new Date(data.endDate);

  const isReviewDisabled =
    !data.sharesToTransfer || !data.pricePerShare || !isValidateDates;

  return (
    <div className="col-12 pt-4 col-lg-4 pt-lg-0">
      <div className="card card-bordered sp-plan">
        <div className="card-inner">
          <h6 className="nk-iv-wg4-title title text-center mb-4">
            {t('OfferSummary')}
          </h6>

          <div className="row">
            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('Class')}</span>
              <span className="h6 fw-500">
                {data.selectedHoldingClassOption?.name || '-'}
              </span>
            </div>

            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('SharesNumber')}</span>
              <span className="h6 fw-500">
                {formatNumber(data.sharesToTransfer)}
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('PricePerShare')}</span>
              <span className="h6 fw-500">
                {formatCurrencyDecimals(data.pricePerShare)}
              </span>
            </div>

            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('TotalPrice')}</span>
              <span className="h6 fw-500">
                {formatCurrencyDecimals(data.totalOfferPrice)}
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('StartDate')}</span>
              <span className="h6 fw-500">
                {data?.startDate
                  ? format(new Date(data.startDate), dateFormat)
                  : '-'}
              </span>
            </div>

            <div className="col-12 col-lg-6 text-center mb-4">
              <span className="sub-text">{t('EndDate')}</span>
              <span className="h6 fw-500">
                {data?.endDate
                  ? format(new Date(data.endDate), dateFormat)
                  : '-'}
              </span>
            </div>
          </div>

          <div className="nk-block-head-content text-center w-100 mt-auto">
            <Button
              onClick={actions.handleReviewTradingOffer}
              disabled={isReviewDisabled}
              lgSize
            >
              {t('ReviewOffer')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTradingOfferResumeSection;
